import { useSelector } from "react-redux";
import { ResponseTab } from "../../RFIS/ResponstTab";

export const Questionnaire = () => {
  const { client_id, client_secret } = useSelector(
    (state) => state.clientSecrets
  );
  return (
    <div className="w-full ">
      {client_id && client_secret && (
        <ResponseTab
          clientSecrets={{ client_id, client_secret }}
          route={"/questionnaires?hideNavigation=true"}
          heading={"View Questionnaires"}
          desc={"questionnaires"}
        />
      )}
    </div>
  );
};
